import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@mui/material/styles";
import styles from "../styles";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContentWrapper from "../../../components/SnackbarContentWrapper";
import { postStudentAccommodation } from "../../../services/faculty/v1/faculty";
import { connect } from "react-redux";
import ADANotificationText from "./ADANotificationText";
import TitleIXNotificationText from "./TitleIXNotificationText";
import ADATitleIXNotificationText from "./ADATitleIXNotificationText";

function ActionNeeded(props) {
  const useStyles = styles;
  const theme = useTheme();
  const classes = useStyles();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  const ADA = "ADA";
  const TitleIX = "Title IX";
  const ADATitleIX = "ADA/Title IX";

  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const modalContentRef = useRef(null);

  const [openSuccess, setOpenSuccess] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("");

  // =========================================================================================================================
  const handlePostStudentAccommodation = async (accommodation) => {
    await postStudentAccommodation(accommodation)
      .then((res) => {
        setSnackbarType("success");
        setSnackbarMessage("Created student accommodation");
        setOpenSuccess(true);
        renderSnackbar();
        props.setUpdate({
          studentIrn: `${accommodation.studentIrn}`,
          courseOfferingId: `${accommodation.courseOfferingId}`,
        });
        props.setOpenModal(false);
      })
      .catch((error) => {
        console.log(error);
        setSnackbarType("error");
        setSnackbarMessage("Failed to create student accommodation.");
        setOpenSuccess(true);
        renderSnackbar();
      });
  };

  const handleGotItClick = () => {
      // Helper function to create base accommodation object
      const createBaseObject = () => ({
        studentAccommodationInfoId: props.actionNeededObject.studentAccommodationInfoId,
        facultyIrn: props.actionNeededObject.facultyIrn,
        facultyPersonId: props.actionNeededObject.facultyPersonId,
        studentIrn: props.actionNeededObject.studentIrn,
        studentPersonId: props.actionNeededObject.studentPersonId,
        courseOfferingId: props.actionNeededObject.courseOfferingId,
        notes: props.actionNeededObject.notes,
        isFinalGradePosted: props.actionNeededObject.finalGradePosted,
        dateModified: new Date().toISOString(),
        modifiedBy: props.facultyDemographics?.username,
        disabilityType: props.actionNeededObject.disabilityType,
        acknowledgedDisabilityType: props.actionNeededObject.notificationType || props.actionNeededObject.disabilityType
      });

      if (props.actionNeededObject.receivingFromFwsDatabase) {
        const isWithinDateRange = (accommodation) => {
          if (
            !(
              accommodation.accommodationStartDate === null &&
              accommodation.accommodationEndDate === null
            )
          ) {
            const startDate = new Date(accommodation.accommodationStartDate);
            const endDate = new Date(accommodation.accommodationEndDate);
            const courseStartDate = props.actionNeededObject.courseStartDate
              ? new Date(props.actionNeededObject.courseStartDate)
              : null;
            const courseEndDate = props.actionNeededObject.courseEndDate
              ? new Date(props.actionNeededObject.courseEndDate)
              : null;
            return (
              (endDate &&
                endDate >= courseStartDate &&
                endDate <= courseEndDate) ||
              (startDate &&
                startDate >= courseStartDate &&
                startDate <= courseEndDate) ||
              (startDate &&
                endDate &&
                startDate <= courseStartDate &&
                endDate >= courseEndDate)
            );
          }
          return true;
        };

        const isCourseMatch = (accommodation) => {
          return accommodation.courseId === null
            ? true
            : accommodation.courseId === props.actionNeededObject.courseId
            ? true
            : false;
        };

        const isApproved = (accommodation) => {
          return (
            accommodation.status?.toLowerCase() === "approved" ||
            accommodation.status === null
          );
        };

        const accommodationsToAcknowledge = props.actionNeededObject.dbResponse
          ?.filter(
            (ack) =>
              isWithinDateRange(ack) &&
              isCourseMatch(ack) &&
              isApproved(ack)
          )
          .map((ack) => ({
            ...ack,
            studentPersonId: props.actionNeededObject.studentPersonId,
            createdBy: ack.createdBy || props.facultyDemographics?.username,
            modifiedBy: props.facultyDemographics?.username,
            dateModified: new Date().toISOString(),
            dateAcknowledged: new Date().toISOString(),
          }));

        const tempObject = {
          ...createBaseObject(),
          dateCreated:
            props.actionNeededObject.courseOfferingId !== 0
              ? props.actionNeededObject.dateCreated
              : new Date().toISOString(),
          createdBy:
            props.actionNeededObject.courseOfferingId !== 0
              ? props.actionNeededObject.createdBy
            
              : props.facultyDemographics?.username,

          facultyAcknowledgements: accommodationsToAcknowledge,
        };

        handlePostStudentAccommodation(tempObject);
      } else {
        const handleCriteriaMet = (accommodation) => {
          const courseStartDate = props.actionNeededObject.courseStartDate
            ? new Date(props.actionNeededObject.courseStartDate)
            : null;
          const courseEndDate = props.actionNeededObject.courseEndDate
            ? new Date(props.actionNeededObject.courseEndDate)
            : null;
          const startDate = accommodation.startDate
            ? new Date(accommodation.startDate)
            : null;
          const endDate = accommodation.endDate
            ? new Date(accommodation.endDate)
            : null;
          const isApproved = accommodation.status?.toLowerCase() === "approved";
          // if courseId is null - it is not specific to a course. otherwise, courseId has to match
          const accommodationCourseMatch =
            accommodation.courseId === null
              ? true
              : accommodation.courseId === props.actionNeededObject.courseId
              ? true
              : false;

          if (isApproved && accommodationCourseMatch) {
            const conditions = [
              // End date exists and is within range of course start date and course end date
              endDate && endDate >= courseStartDate && endDate <= courseEndDate,
              // Start date exists and is within range of course start date and course end date
              startDate &&
                startDate >= courseStartDate &&
                startDate <= courseEndDate,
              // Both dates exist and start date is before course start date and end date is after course end date
              startDate &&
                endDate &&
                startDate <= courseStartDate &&
                endDate >= courseEndDate,
              // Both dates are null
              !startDate && !endDate,
              // Only startDate exists and current date is after startDate
              startDate && !endDate && courseStartDate >= startDate,
              // Only endDate exists and current date is before endDate
              !startDate && endDate && courseEndDate <= endDate,
            ];

            if (conditions.some((condition) => condition)) {
              return true;
            }
          }

          return false;
        };

        const createAcknowledgement = (
          accommodationObject,
          accommodationType,
          isTemp = false,
          isSpecialArr = false
        ) => {
          // If accommodationType is null/"null" and specialArrangements exists, use specialArrangements for accommodationType
          if ((!accommodationObject.accommodationType || accommodationObject.accommodationType === "null") 
              && accommodationObject.specialArrangements) {
            return {
              disabilityType: props.actionNeededObject.disabilityType,
              acknowledgedDisabilityType: props.actionNeededObject.notificationType || props.actionNeededObject.disabilityType,
              accommodationType: accommodationObject.specialArrangements,
              courseId: accommodationObject.courseId || null,
              specialArrangements: null,
              accommodationStartDate: isTemp ? accommodationObject.startDate : null,
              accommodationEndDate: isTemp 
                                    ? accommodationObject.endDate 
                                    : accommodationObject.accomEndDate 
                                    ? accommodationObject.accomEndDate : null,
              status: !isTemp ? null : accommodationObject.status,
              active: !isTemp
                ? accommodationObject.isActive
                : accommodationObject.status?.toLowerCase() === "approved"
                ? true
                : false,
              dateCreated: new Date().toISOString(),
              dateModified: new Date().toISOString(),
              createdBy: props.facultyDemographics?.username,
              modifiedBy: props.facultyDemographics?.username,
              dateAcknowledged: new Date().toISOString(),
            };
          }
        
          // Original behavior for all other cases
          return {
            disabilityType: props.actionNeededObject.disabilityType,
            acknowledgedDisabilityType: props.actionNeededObject.notificationType || props.actionNeededObject.disabilityType,
            accommodationType: accommodationType,
            courseId: accommodationObject.courseId || null,
            specialArrangements: isSpecialArr
              ? null
              : accommodationObject.specialArrangements,
            accommodationStartDate: isTemp ? accommodationObject.startDate : null,
            accommodationEndDate: isTemp 
                                  ? accommodationObject.endDate 
                                  : accommodationObject.accomEndDate 
                                  ? accommodationObject.accomEndDate : null,
            status: !isTemp ? null : accommodationObject.status,
            active: !isTemp
              ? accommodationObject.isActive
              : accommodationObject.status?.toLowerCase() === "approved"
              ? true
              : false,
            dateCreated: new Date().toISOString(),
            dateModified: new Date().toISOString(),
            createdBy: props.facultyDemographics?.username,
            modifiedBy: props.facultyDemographics?.username,
            dateAcknowledged: new Date().toISOString(),
          };
        }; 

        const dbResponse = props.actionNeededObject?.dbResponse;
        const permAccommodationTypes = props.actionNeededObject?.dbResponse?.accommodationType 
          ? props.actionNeededObject?.dbResponse?.accommodationType?.split(";")
          : [];
        const permSpecialArrangements = props.actionNeededObject?.dbResponse
          .specialArrangements
          ? [props.actionNeededObject?.dbResponse]
          : [];
        const tempFacultyAcknowledgements = dbResponse.isActive || dbResponse.accomEndDate !== null
          ? [
              ...(permAccommodationTypes
                ?.filter((acc) => acc)
                ?.map((acc) =>
                  createAcknowledgement(
                    dbResponse, 
                    acc
                  )
                )
              ),

              ...(permSpecialArrangements
                ?.filter((acc) => acc)
                ?.map((acc) => 
                  createAcknowledgement(
                    acc,
                    acc.specialArrangements,
                    false,
                    true
                  )
                )
              ),

              ...dbResponse.tempAccoms
                ?.filter((acc) => handleCriteriaMet(acc) && acc.accommodationType)
                .map((acc) => {
                  return acc.accommodationType
                    ?.split(";")
                    .map((accType) =>
                      createAcknowledgement(acc, accType, true)
                    );
                })
                ?.flat(),

              ...dbResponse.tempAccoms
                ?.filter((acc) => handleCriteriaMet(acc) && acc.specialArrangements && acc.accommodationType)
                .map((acc) =>
                  createAcknowledgement(
                    acc,
                    acc.specialArrangements,
                    true,
                    true
                  )
                ),
            ]
          : [
              ...dbResponse.tempAccoms
                ?.filter((acc) => handleCriteriaMet(acc) && acc.accommodationType)
                .map((acc) => {
                  return acc.accommodationType
                    ?.split(";")
                    .map((accType) =>
                      createAcknowledgement(acc, accType, true)
                    );
                })
                ?.flat(),

              ...dbResponse.tempAccoms
                ?.filter((acc) => handleCriteriaMet(acc) && acc.specialArrangements && acc.accommodationType)
                .map((acc) =>
                  createAcknowledgement(
                    acc,
                    acc.specialArrangements,
                    true,
                    true
                  )
                ),
            ];

        const tempObject = {
          ...createBaseObject(),
          dateCreated: new Date().toISOString(),
          createdBy: props.facultyDemographics?.username,
          facultyAcknowledgements: tempFacultyAcknowledgements,
        };

        handlePostStudentAccommodation(tempObject);
      }
    // }
  };
  // =========================================================================================================================

  // =========================================================================================================================
  // Handles Modal navigation and accessibility.
  useEffect(() => {
    const handleScroll = () => {
      if (modalContentRef.current) {
        const { scrollTop, scrollHeight, clientHeight } =
          modalContentRef.current;

        const isScrolledToBottom = scrollTop + clientHeight >= scrollHeight - 5;
        setScrolledToBottom(isScrolledToBottom);
      }
    };

    const modalContentElement = modalContentRef.current;
    if (modalContentElement) {
      modalContentElement.addEventListener("scroll", handleScroll);
      handleScroll();
    }

    return () => {
      if (modalContentElement) {
        modalContentElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (modalContentRef.current) {
      switch (event.key) {
        case "ArrowUp":
          modalContentRef.current.scrollBy({
            top: -220,
            behavior: "smooth",
          });
          break;
        case "ArrowDown":
          modalContentRef.current.scrollBy({
            top: 220,
            behavior: "smooth",
          });
          break;
        default:
          break;
      }
    }
  };
  // =========================================================================================================================

  // =========================================================================================================================
  // Handles rendering of snackbar to screen after successful or failed acknowledgements POST endpoint call.
  const renderSnackbar = () => (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={openSuccess}
        autoHideDuration={snackbarType === "success" ? 10000 : 13000}
        onClose={handleCloseSnackBar}
      >
        <SnackbarContentWrapper
          onClose={handleClose}
          handleRetryClick={handleRetryApiCall}
          variant={snackbarType}
          message={snackbarMessage}
        />
      </Snackbar>
    </>
  );

  const handleCloseSnackBar = (event, reason) => {
    setOpenSuccess(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  const handleRetryApiCall = () => {
    switch (snackbarMessage) {
      case "Failed to create student accommodation.":
        handleGotItClick();
        break;
      default:
        break;
    }
  };
  // =========================================================================================================================

  return (
    <>
      {/* first block is for accommodation error pop up for contacting SAO */}
      {props.actionNeededObject.displayAccommodationTypes.length < 1 ? (
        <Grid className={classes.errorModuleContainer}>
          <Box
            className={
              matches
                ? classes.closeButtonContainer
                : classes.mobileCloseButtonContainer
            }
            onClick={() => props.setOpenModal(false)}
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Escape") {
                event.preventDefault();
                props.setOpenModal(false);
                return;
              }
              if (
                (event.key === "Enter" || event.key === " ")
              ) {
                event.preventDefault();
                props.setOpenModal(false);
              }
            }}
            role="button"
            aria-label="Close"
            style={{
              cursor: "pointer"
            }}
          >
            <Typography className={classes.closeButtonText}>Close</Typography>
          </Box>

          <Box>
            <Typography
              className={classes.titleText}
              component="h2"
              id="action-needed-modal-title"
            >
              Action Required: Contact Student Accommodations Office or Title IX Office
            </Typography>
          </Box> 

          <Box>
            <Typography className={classes.greetingText}>
              {`Hello ${props.facultyDemographics.firstName} ${props.facultyDemographics.lastName},`}
            </Typography>
          </Box>

          <Box className={classes.infoContainer}>
            <Typography className={classes.boldText}>
              Regarding: &nbsp;
              <Typography>
                {props.actionNeededObject?.studentName.includes("null")
                  ? ""
                  : props.actionNeededObject?.studentName}
              </Typography>
            </Typography>
            <Typography className={classes.boldText}>
              IRN: &nbsp;
              <Typography>{props.actionNeededObject?.studentIrn}</Typography>
            </Typography>
            <Typography className={classes.boldText}>
              Course: &nbsp;
              <Typography>{props.actionNeededObject?.courseId}</Typography>
            </Typography>
            <Typography className={classes.boldText}>
              Course Start Date: &nbsp;
              <Typography>
                {props.actionNeededObject?.courseStartDate}
              </Typography>
            </Typography>
            <Typography className={classes.boldText}>
              Course End Date: &nbsp;
              <Typography>{props.actionNeededObject?.courseEndDate}</Typography>
            </Typography>
          </Box>
          <Box>
            <Typography className={classes.errorText}>
              The Student Accommodations Office (SAO) and Title IX Office would like to inform you about accommodated student(s) in your course. However, it currently appears that a system issue is preventing the provision of detailed information regarding accommodated student(s).
            </Typography>
          </Box>

          <Box style={{ marginTop: "16px" }}>
            <Typography className={classes.errorText}>
              Please use the <strong>Type</strong> field to determine the appropriate office to contact:
            </Typography>
          </Box>

          <Box style={{ marginTop: "16px", marginLeft: "15px" }}>
            <ul style={{ margin: 0, paddingLeft: "15px" }}>
              <li>
                <Typography className={classes.errorText} style={{ display: "inline" }}>
                  <strong>ADA</strong>— Call 602-557-1157 or Email{" "}
                  <a href="mailto:SAO@phoenix.edu" style={{ color: "#30718D", textDecoration: "underline", fontFamily: "inherit", fontSize: "inherit", fontWeight: "inherit" }}>SAO@phoenix.edu</a>
                </Typography>
              </li>
              <li style={{ marginTop: "8px" }}>
                <Typography className={classes.errorText} style={{ display: "inline" }}>
                  <strong>Title IX</strong> — Call 602-557-6176 or Email{" "}
                  <a href="mailto:Title.IXUOP@phoenix.edu" style={{ color: "#30718D", textDecoration: "underline", fontFamily: "inherit", fontSize: "inherit", fontWeight: "inherit" }}>Title.IXUOP@phoenix.edu</a>
                </Typography>
              </li>
              <li style={{ marginTop: "8px" }}>
                <Typography className={classes.errorText} style={{ display: "inline" }}>
                  <strong>ADA/Title IX</strong> — Contact either office based on the student issue, or reach out to both if needed
                </Typography>
              </li>
            </ul>
          </Box>

          <Box style={{ marginTop: "16px" }}>
            <Typography className={classes.errorText}>
              Please get in touch as soon as possible for more information about the accommodated student(s) in your course.
            </Typography>
          </Box>

          <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <Button
            className={classes.gotItButton}
            style={{
              alignSelf: "center",
              borderRadius: "30px",
              padding: `${matches ? "8px 32px" : "2px 16px"}`,
              margin: "30px 16px 10px 0px",
              width: matches ? "253px" : "200px",
              height: "51px",
              backgroundColor: "#DC3727",
              color: "white",
              textTransform: "none",
            }}
            aria-label="Got it, acknowledgement"
            variant="contained"
            onClick={() => props.setOpenModal(false)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                props.setOpenModal(false);
              }
            }}
            tabIndex={0}
          >
            Got it!
          </Button>
        </div>
        </Grid>
      ) : (
      <Grid
        container
        role="dialog"
        aria-labelledby="action-needed-modal-title"
        className={classes.actionContainer}
        component={Paper}
        elevation={2}
        xs={12}
      >
        <Box
          className={
            matches
              ? classes.closeButtonContainer
              : classes.mobileCloseButtonContainer
          }
          onClick={
            props.alreadyAcknowledged
              ? () => props.setOpenModal(false)
              : scrolledToBottom
              ? () => props.setOpenModal(false)
              : null
          }
          tabIndex={props.alreadyAcknowledged ? 0 : scrolledToBottom ? 0 : -1}
          onKeyDown={(event) => {
            if (event.key === "Escape") {
              event.preventDefault();
              props.setOpenModal(false);
              return;
            }
            if (
              (props.alreadyAcknowledged || scrolledToBottom) &&
              (event.key === "Enter" || event.key === " ")
            ) {
              event.preventDefault();
              props.setOpenModal(false);
            }
          }}
          role="button"
          aria-label="Close"
          aria-disabled={props.alreadyAcknowledged || !scrolledToBottom}
          style={{
            cursor: props.alreadyAcknowledged
              ? "pointer"
              : scrolledToBottom
              ? "pointer"
              : "not-allowed",
            opacity: props.alreadyAcknowledged ? 1 : scrolledToBottom ? 1 : 0.5,
          }}
        >
          <Typography className={classes.closeButtonText}>Close</Typography>
        </Box>
        <Box
          className={classes.mainPopUpContent}
          ref={modalContentRef}
          style={{ overflowY: "auto", outline: "none" }}
        >
          <Box>
            <Typography
              className={classes.titleText}
              component="h2"
              id="action-needed-modal-title"
            >
              Action needed: New student accommodation
            </Typography>
          </Box>
          <Box>
            <Typography className={classes.greetingText}>
              {`Hello ${props.facultyDemographics.firstName} ${props.facultyDemographics.lastName},`}
            </Typography>
          </Box>
          <Box className={classes.infoContainer}>
            <Typography className={classes.boldText}>
              Regarding: &nbsp;
              <Typography>
                {props.actionNeededObject?.studentName.includes("null")
                  ? ""
                  : props.actionNeededObject?.studentName}
              </Typography>
            </Typography>
            <Typography className={classes.boldText}>
              IRN: &nbsp;
              <Typography>{props.actionNeededObject?.studentIrn}</Typography>
            </Typography>
            <Typography className={classes.boldText}>
              Course: &nbsp;
              <Typography>{props.actionNeededObject?.courseId}</Typography>
            </Typography>
            <Typography className={classes.boldText}>
              Course Start Date: &nbsp;
              <Typography>
                {props.actionNeededObject?.courseStartDate}
              </Typography>
            </Typography>
            <Typography className={classes.boldText}>
              Course End Date: &nbsp;
              <Typography>{props.actionNeededObject?.courseEndDate}</Typography>
            </Typography>
          </Box>
          {props.actionNeededObject.notificationType === TitleIX && <TitleIXNotificationText displayAccommodationTypes={props.actionNeededObject.displayAccommodationTypes} />}
          {props.actionNeededObject.notificationType === ADATitleIX && <ADATitleIXNotificationText displayAccommodationTypes={props.actionNeededObject.displayAccommodationTypes} />}
          {props.actionNeededObject.notificationType === ADA && <ADANotificationText displayAccommodationTypes={props.actionNeededObject.displayAccommodationTypes} />}
        </Box>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <Button
            className={classes.gotItButton}
            style={{
              alignSelf: "center",
              borderRadius: "30px",
              padding: `${matches ? "8px 32px" : "2px 16px"}`,
              margin: "30px 16px 10px 0px",
              width: matches ? "253px" : "200px",
              height: "51px",
              backgroundColor: props.alreadyAcknowledged
                ? "#B0B0B0"
                : scrolledToBottom
                ? "#DC3727"
                : "#B0B0B0",
              color: props.alreadyAcknowledged
                ? "#6D6D6D"
                : scrolledToBottom
                ? "white"
                : "#6D6D6D",
              textTransform: "none",
            }}
            aria-label="Got it, acknowledgement"
            variant="contained"
            onClick={handleGotItClick}
            disabled={props.alreadyAcknowledged ? true : !scrolledToBottom}
          >
            Got it!
          </Button>
        </div>
        {openSuccess && renderSnackbar()}
      </Grid>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    facultyDemographics: state.demographics,
  };
};

export default connect(mapStateToProps)(ActionNeeded);
